<template>
	<div :disabled="disabled" class="box is-relative">
		<div v-if="$slots['outer-corner']" class="box-outer-corner has-background-black-ter">
			<slot name="outer-corner" />
		</div>
		<slot />
		<template v-if="simple">
			<dp-svg class="box-corner has-secondary-transparent is-abs-right is-abs-top is-rotated-90" svg="cornerSimple" />
		</template>
		<template v-else>
			<dp-svg class="box-corner is-abs-left is-abs-top" svg="cornerFancy" />
			<dp-svg class="box-corner is-abs-right is-abs-bottom is-rotated-180" svg="cornerFancy" />
		</template>
	</div>
</template>

<script>
export default {
	name: 'DpBox',
	props: {
		simple: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},
};
</script>
